<template>
    <section>
        <Header />
        <div class="container profile-container">
            <div class="row">
                <!-- left column -->
                <div class="col-sm-3">
                    <div class="text-center">
                        <img src="/img/profile_default.png" class="avatar img-circle" alt="avatar" style="width: 100%;">
                    </div>
                </div>

                <!-- edit form column -->
                <div class="col-sm-9 personal-info" style="text-align: left;">
                    <div class="form-group">
                        <label class="control-label">First name:</label>
                        <input class="form-control" type="text" v-model="user.first_name">
                    </div>
                    <div class="form-group">
                        <label class="control-label">Last name:</label>
                        <input class="form-control" type="text" v-model="user.last_name">
                    </div>
                    <div class="form-group">
                        <label class="control-label">Email:</label>
                        <input class="form-control" type="email" v-model="user.email">
                    </div>
                    <div class="form-group">
                        <div class="col-sm-12">
                            <b-button type="is-danger" @click="logout()" class="pull-left">Logout</b-button>
                            <b-button type="is-primary" @click="saveUser()" class="pull-right" v-if="!savingLoading">Save changes</b-button>
                            <b-button type="is-primary" class="pull-right" v-if="savingLoading" loading>Save changes</b-button>
                            <b-button type="is-warning" @click="_changePassword()" class="pull-right" style="margin-right: 10px;">Change password</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios';
    import jwt_decode from 'jwt-decode'
    import {getJWT} from '../../logic/global'
    import {getUser, updateUser} from '../../logic/account'
    import constants from '../../constants'
    import ChangePassword from '../../components/ChangePassword'
    import {changeUserPassword} from '../../logic/account'
    import Header from '../../components/Header'


    let user = {}
    let savingLoading = false

    export default {
        data(){
            return {
                user: user,
                savingLoading: savingLoading
            }
        },
        components: {Header},
        methods : {
            _getUser: function(){
                let token = jwt_decode(getJWT());
                getUser(token['id']).then(response => {
                    this.user = response.data
                })
            },
            _changePassword: function(){
                let _this = this;
                _this.$modal.open({
                    parent: this,
                    component: ChangePassword,
                    hasModalCard: true,
                    props: {},
                    events: {
                        'changed_password': changed_password => {
                            let token = jwt_decode(getJWT());
                            changeUserPassword(token["id"], changed_password).then(response => {
                                this.showSuccessMsg('You have successfully updated your password.')
                            })
                        }
                    }
                })
            },
            showSuccessMsg: function(message){
                this.$toast.open({
                    message: message,
                    type: 'is-success'
                })
            },
            saveUser: function(){
                let _this = this;
                let token = jwt_decode(getJWT());
                _this.savingLoading = true;
                updateUser(token["id"], this.user).then(response => {
                    _this.savingLoading = false;
                    this.showSuccessMsg("You have successfully updated your profile")
                })
            },
            logout: function(){
                localStorage.removeItem('jwt');
                this.$router.push({name: "login"})
            }
        },
        mounted: function(){
            this._getUser()
        }
    }
</script>


<style scoped>
   .profile-container{
        display: block;
        float: none;
        margin-top: 50px;
        background: #fff;
        padding: 40px;
        text-align:center;
    }

    
    @media (min-width: 768px){
       
    }

    
</style>
